import type { IntermediateStopDTO } from '@/types/dto/agent';
import { formatTime } from '@/utils/dateTime';
import { Icons, Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface LegIntermediateStopProps {
  stop: IntermediateStopDTO;
}

const LegIntermediateStop: FC<LegIntermediateStopProps> = ({ stop }) => {
  const arrivalTime = formatTime(stop.arrivalTime);
  const departureTime = formatTime(stop.departureTime);

  return (
    <tr className="relative">
      <td className="relative py-1 pr-2 text-left">
        <Icons.destination
          width={10}
          height={10}
          className="absolute -left-[19px] top-1/2 -translate-x-full -translate-y-1/2 bg-white text-neutral-light"
        />
        <Typography variant="body2" className="text-wrap">
          {stop.name}
        </Typography>
      </td>
      <td className="px-2 py-1 text-center">
        <Typography variant="body2">{arrivalTime}</Typography>
      </td>
      <td className="px-2 py-1 text-center">
        <Typography variant="body2">{departureTime}</Typography>
      </td>
    </tr>
  );
};

export default LegIntermediateStop;
